// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"342":"17b69ec7","495":"291997d0","540":"983c632f","608":"7591626e","869":"fcfa94bd","880":"50ab3c69","888":"a0f159a2"}[chunkId] + ".js";
};